export const SET_HRES94U_INDEX_DISP = 'SET_HRES94U_INDEX_DISP'
export const GET_HRES94U_INDEX_DISP = 'GET_HRES94U_INDEX_DISP'
export const SET_HRES94U_DETAIL_DISP = 'SET_HRES94U_DETAIL_DISP'
export const GET_HRES94U_DETAIL_DISP = 'GET_HRES94U_DETAIL_DISP'
export const SET_HRES94U_COLUMNS = 'SET_HRES94U_COLUMNS'
export const GET_HRES94U_COLUMNS = 'GET_HRES94U_COLUMNS'
export const SET_HRES94U_LABELS = 'SET_HRES94U_LABELS'
export const GET_HRES94U_LABELS = 'GET_HRES94U_LABELS'
export const RECEIVED_HRES94U_COLUMNS_LABELS = 'RECEIVED_HRES94U_COLUMNS_LABELS'
export const SET_HRES94U_INDEX = 'SET_HRES94U_INDEX'
export const GET_HRES94U_INDEX = 'GET_HRES94U_INDEX'
export const RECEIVED_HRES94U_INDEX = 'RECEIVED_HRES94U_INDEX'
export const SET_HRES94U_INDEX_SELECTED = 'SET_HRES94U_INDEX_SELECTED'
export const GET_HRES94U_INDEX_SELECTED = 'GET_HRES94U_INDEX_SELECTED'
export const SET_HRES94U_DETAIL = 'SET_HRES94U_DETAIL'
export const GET_HRES94U_DETAIL = 'GET_HRES94U_DETAIL'
export const RECEIVED_HRES94U_DETAIL = 'RECEIVED_HRES94U_DETAIL'
export const TOGGLE_HRES94U_PAGE = 'TOGGLE_HRES94U_PAGE'
export const POST_HRES94U_SEND_APPROVE = 'POST_HRES94U_SEND_APPROVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres94u/mutation-types.js